<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ReviewAvailableDomainsSettingsDialog',
  props: {
    activeTab: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState({
      brandsWithDomains: state => state.review.filter.items,
      brands: state => state.reviewSettings.availableDomains.items,
    }),
  },
  watch: {
    selectedDomain(val) {
      if (val) {
        const filteredBrandWithAvailableDomains = this.brands.filter(
          brand => brand.id === val.brandId,
        ).shift();
        const availableDomainObjects = filteredBrandWithAvailableDomains.domains;
        const filteredAvailableDomainObjectsByDomain = availableDomainObjects.filter(
          domain => domain.domain.id === val.id,
        );
        const mappedAvailableDomains = filteredAvailableDomainObjectsByDomain.map(
          availableDomain => availableDomain.availableDomain,
        );
        const mappedAvailableDomainIds = mappedAvailableDomains.map(domain => domain.id);
        this.availableDomains = this.selectedBrand.domains.filter(
          domain => !mappedAvailableDomainIds.includes(domain.id),
        );
      }
    },
  },
  data() {
    return {
      dialog: false,
      selectedBrand: {},
      selectedDomain: null,
      selectedAvailableDomain: null,
      availableDomains: [],
    };
  },
  methods: {
    ...mapActions({
      fetchBrandsAndDomains: 'review/fetchBrandsAndDomains',
      addAvailableDomain: 'reviewSettings/addAvailableDomain',
    }),
    save() {
      const domainId = this.selectedDomain.id;
      const availableDomainId = this.selectedAvailableDomain.id;
      this.addAvailableDomain({ domainId, availableDomainId })
        .then(() => {
          this.$emit('save');
        });
      this.dialog = false;
    },
    close() {
      this.selectedAvailableDomain = null;
      this.selectedDomain = null;
      this.dialog = false;
    },
  },
  created() {
    this.fetchBrandsAndDomains();
  },
  beforeUpdate() {
    this.selectedBrand = this.brandsWithDomains.filter(
      brand => brand.id === this.brands[this.activeTab].id,
    ).shift();
  },

};
</script>

<template>
  <v-dialog
    v-model="dialog"
    max-width="600px"
    persistent
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        class="mr-5"
        color="success"
        round
      >
        {{ $t('reviewSettings.title.addButton') }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline ml-4">
          {{ $t('reviewSettings.dialog.title') }} {{ selectedBrand.name }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-select
                v-model="selectedDomain"
                :items="selectedBrand.domains"
                :label="$t('reviewSettings.dialog.selectDomain')"
                item-text="name"
                return-object
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                v-if="selectedDomain"
                v-model="selectedAvailableDomain"
                :items="availableDomains"
                :label="$t('reviewSettings.dialog.chooseAvailableDomain')"
                item-text="name"
                return-object
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="close"
          color="error"
          flat
        >
          {{ $t('reviewSettings.dialog.close') }}
        </v-btn>
        <v-btn
          @click="save"
          :disabled="!selectedAvailableDomain"
          color="success"
          flat
        >
          {{ $t('reviewSettings.dialog.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/review/ReviewAvailableDomainsSettingsDialog.vue